import React, { useState, useRef, useEffect } from 'react';
import { config } from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Page, Text, View, Document, StyleSheet, PDFDownloadLink, Font, Svg, Line  } from '@react-pdf/renderer';
import ReactPDF from '@react-pdf/renderer';
import '../shared/fonts';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    backgroundColor: '#ffffff'
  },
  text: {
    fontFamily: "iransans",
    border : "1px solid #000000",
    height:"50px",
    
  }
});

export default function  PrintTimeing1(props){
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loadingTiming, setLoadingTiming] = useState(false);
  const [pdfSize, setPdfSize] = useState([800, 1200]);
  const [timings, setTimings] = useState([]);
  const [dayParts, setDayParts] = useState([]);
  const [weekDays, setWeekDays] = useState([]);
  const [classes, setClasses] = useState([]);
  const [classCount, setClassCount] = useState(0);
  const [dayRowHeight, setDayRowHeight] = useState(0);

  useEffect(() => {
      setLoadingTiming(true);
      var params = {login:util.getTrustedUser()};
      var url = config.Server+`/school/timing/school/list`;
      console.log("params is>", params);
      console.log("url is>", url);
      axios
          .post(url, params )
          .then(res => {
              var response = res.data;
              if(response.state === "ok"){
                  response = response.data.timings;
                  console.log("resopnse is> ", response[0].dayItems);
                  var dp = [];
                  var wd = [];
                  for(var i=0;i<3;i++){
                    dp.push({index:i, title:util.getTimeIndexName(i)});
                  }
                  for(var i=0;i<5;i++){
                    wd.push({index:i, title:util.getWeekDayName(i)});
                  }
                  var day5 = false;
                  var day6 = false;
                  var time3 = false;
                  var time4 = false;
                  var time5 = false;
                  var cc = response[0].dayItems[0].timePartItems.length;
                  for(var dayInd=0;dayInd<7;dayInd++){
                    for(var ti=0;ti<6;ti++){
                      for(var k=0;k<cc;k++){
                        if(response[dayInd].dayItems[ti].timePartItems[k].teacher != null){
                          if(dayInd == 5) day5 = true;
                          if(dayInd == 6) day6 = true;
                          if(ti == 3) time3 = true;
                          if(ti == 4) time4 = true;
                          if(ti == 5) time5 = true;
                        }
                      }
                    }
                  }
                  
                  if(day6){
                    wd.push({index:5, title:util.getWeekDayName(5)});
                    wd.push({index:6, title:util.getWeekDayName(6)});
                  }
                  else if(day5){
                    wd.push({index:5, title:util.getWeekDayName(5)});
                  }
                  if(time5){
                    dp.push({index:3, title:util.getTimeIndexName(3)});
                    dp.push({index:4, title:util.getTimeIndexName(4)});
                    dp.push({index:5, title:util.getTimeIndexName(5)});
                  }
                  else if(time4){
                    dp.push({index:3, title:util.getTimeIndexName(3)});
                    dp.push({index:4, title:util.getTimeIndexName(4)});
                  }
                  else if(time3){
                    dp.push({index:3, title:util.getTimeIndexName(3)});
                  }
                  setDayParts(dp);
                  setWeekDays(wd);
                  var classes = [];
                  for(var i=0;i<cc;i++){
                    classes.push({id:response[0].dayItems[0].timePartItems[i].schoolClass.id, title:response[0].dayItems[0].timePartItems[i].schoolClass.name})
                  }
                  setClassCount(cc);
                  setClasses(classes);
                  setTimings(response);
                  setDayRowHeight(props.dataRowHeight*cc);

                  var pw = (props.margin * 2) + props.dayColWidth + props.classColWidth + (dp.length * props.dataColWidth);
                  var ph = (props.margin * 2) + props.headerHeight + props.captionRowHeight + (wd.length * cc * props.dataRowHeight);
                  console.log("classes is >", classes)
                  setPdfSize([pw, ph]);
                  
                  setLoadingTiming(false);
                  if(props.onComplete) props.onComplete(true, 'success');
              }
              else{
                  setErrorMessage(response.message);
                  setErorVisible(true);
                  setLoadingTiming(false);
                  if(props.onComplete) props.onComplete(false, response.message);
              }
          })
          .catch(error => {
              setErrorMessage(error.code + "," + error.message);
              setErorVisible(true);
              setLoadingTiming(false);
              if(props.onComplete) props.onComplete(false, error.code + "," + error.message);
          });
     
  }, []);

  return(
         <Document>
             <Page size={pdfSize} style={styles.page}>
                {
                  weekDays.map((day)=>{
                    return(
                      <>
                      <view  key={"view_day_" + day.index} style={{position:"absolute", left:pdfSize[0]-props.margin-props.dayColWidth, top:(day.index*dayRowHeight)+props.margin + props.headerHeight + props.captionRowHeight, width:props.dayColWidth, height:dayRowHeight, fontFamily:"iransans", fontSize:props.fontSize1, border : "1px solid #000000", display: 'table-cell', verticalAlign:"middle"}}>
                        <Text key={"txt_day_" + day.index} style={{position:"relative", textAlign:"center", marginTop:parseInt((dayRowHeight/2)-(props.dataRowHeight/2)) +"px"}}>{day.title}</Text>
                      </view>
                      <view  key={"view_daytop_" + day.index} style={{position:"absolute", left:props.margin, top:(day.index*dayRowHeight)+props.margin + props.headerHeight + props.captionRowHeight-2, width:(props.dataColWidth*dayParts.length)+props.classColWidth+props.dayColWidth, height:5, fontFamily:"iransans", fontSize:props.fontSize1, backgroundColor:"#000"}}>
                      </view>
                      {
                        classes.map((cls, index)=>{
                          return(
                            <view  key={"view_class_" + day.index+"_"+cls.id} style={{position:"absolute", left:(dayParts.length * props.dataColWidth)+props.margin, top:(index*props.dataRowHeight)+(day.index*dayRowHeight)+props.margin + props.headerHeight + props.captionRowHeight, width:props.classColWidth, height:props.dataRowHeight, fontFamily:"iransans", fontSize:props.fontSize1, border : "1px solid #000000", display: 'table-cell', verticalAlign:"middle"}}>
                              <Text key={"txt_class_" + day.index+"_"+cls.id} style={{position:"relative", textAlign:"center", marginTop:"3px"}}>{cls.title}</Text>
                            </view>
                          )
                        })
                      }
                      {
                        dayParts.map((ti)=>{
                          return(
                            <>
                              {
                                classes.map((cls, index)=>{
                                  var item = timings[day.index].dayItems[ti.index].timePartItems[index];
                                  return(
                                    <view  key={"view_data_" + day.index+"_" + ti.index+"_"+cls.id} 
                                      style={{position:"absolute", left:props.margin + ((dayParts.length - ti.index - 1) * props.dataColWidth), top:(index*props.dataRowHeight)+(day.index*dayRowHeight)+props.margin + props.headerHeight + props.captionRowHeight, width:props.dataColWidth, height:props.dataRowHeight, fontFamily:"iransans", fontSize:props.fontSize1, border : "1px solid #000000", display: 'table-cell', verticalAlign:"middle", paddingRight:"3px"}}>
                                    {
                                      (item.teacher == null)?
                                      <></>
                                      :
                                      (item.teacher2 == null)?
                                      <Text key={"txt_data_" + day.index+"_" + ti.index+"_"+cls.id} style={{position:"relative", textAlign:"right", marginTop:((props.dataRowHeight/2)-6) +"px", maxWidth:props.dataColWidth+"px"}}>
                                        {item.teacher.firstname}&nbsp;{item.teacher.lastname} - {item.course.name}
                                      </Text>
                                      :
                                      <>
                                        <view style={{borderLeft:"1px dotted #b0b0b0", position:"absolute", left:(props.dataColWidth/2)-2, width:(props.dataColWidth/2), top:1, height:props.dataRowHeight, fontFamily:"iransans", fontSize:props.fontSize2}}>
                                          <Text key={"txt_data_" + day.index+"_" + ti.index+"_"+cls.id} style={{position:"relative", textAlign:"right", marginTop:((props.dataRowHeight/2)-6) +"px", maxWidth:props.dataColWidth+"px"}}>
                                            {item.teacher.firstname}&nbsp;{item.teacher.lastname} - {item.course.name}
                                          </Text>
                                        </view>
                                        <view style={{position:"absolute", left:1, width:(props.dataColWidth/2)-4, top:1, height:props.dataRowHeight, fontFamily:"iransans", fontSize:props.fontSize2}}>
                                          <Text key={"txt_data_" + day.index+"_" + ti.index+"_"+cls.id} style={{position:"relative", textAlign:"right", marginTop:((props.dataRowHeight/2)-6) +"px", maxWidth:props.dataColWidth+"px"}}>
                                            {item.teacher2.firstname}&nbsp;{item.teacher2.lastname} - {item.course2.name}
                                          </Text>
                                        </view>
                                      </>
                                    }
                                    </view>
                                  )
                                })
                              }
                            </>
                          )
                        })
                      }
                      </>
                    )
                  })
                }
                {
                  dayParts.map((ti)=>{
                    return(
                      <view  key={"view_timepart_" + ti.index} style={{position:"absolute", left:props.margin + ((dayParts.length - ti.index - 1) * props.dataColWidth), top:props.margin + props.headerHeight, width:props.dataColWidth, height:props.captionRowHeight, fontFamily:"iransans", fontSize:props.fontSize1, border : "1px solid #000000", display: 'table-cell', verticalAlign:"middle"}}>
                        <Text key={"txt_timepart_" + ti.index} style={{position:"relative", textAlign:"center", marginTop:((props.captionRowHeight/2)-6) +"px"}}>{ti.title}</Text>
                      </view>
                    )
                  })
                }
                {
                    <view  key={"view_classcaption_1"} style={{position:"absolute", left:props.margin + (dayParts.length * props.dataColWidth), top:props.margin + props.headerHeight, width:props.classColWidth, height:props.captionRowHeight, fontFamily:"iransans", fontSize:props.fontSize1, border : "1px solid #000000", display: 'table-cell', verticalAlign:"middle"}}>
                      <Text key={"txt_classcaption_1"} style={{position:"relative", textAlign:"center", marginTop:((props.captionRowHeight/2)-6) +"px"}}>کلاس</Text>
                    </view>
                }
                {
                    <view  key={"view_classcaption_2"} style={{position:"absolute", left:props.margin + (dayParts.length * props.dataColWidth) + props.classColWidth, top:props.margin + props.headerHeight, width:props.dayColWidth, height:props.captionRowHeight, fontFamily:"iransans", fontSize:props.fontSize1, border : "1px solid #000000", display: 'table-cell', verticalAlign:"middle"}}>
                      <Text key={"txt_classcaption_2"} style={{position:"relative", textAlign:"center", marginTop:((props.captionRowHeight/2)-6) +"px"}}>روز</Text>
                    </view>
                }
                {
                    <view  key={"view_classcaption_3"} style={{position:"absolute", left:props.margin, top:props.margin, width:pdfSize[0]- (2 *props.margin), height:props.headerHeight, fontFamily:"iransans", fontSize:props.fontSize3, border : "1px solid #000000", display: 'table-cell', verticalAlign:"middle"}}>
                      <Text key={"txt_classcaption_4"} style={{position:"relative", textAlign:"center", marginTop:((props.headerHeight/2)-10) +"px"}}>برنامه هفتگی مدرسه: {util.getSchoolName()}</Text>
                    </view>
                }
             </Page>
         </Document>  
    )
}
